// External libraries
import styled from '@emotion/styled';

const InterstitialContainer = styled.div`
  padding: 0 1.5rem;
`;

const CancelAndRTMContainer = styled.div`
  margin-bottom: 6px;
  margin-top: 18px;
`;

const HaveAnAccountLogInContainer = styled.div`
  margin-bottom: -18px;
  margin-top: 18px;
`;

export {
  CancelAndRTMContainer,
  HaveAnAccountLogInContainer,
  InterstitialContainer,
};
